import { render } from "./SignOutButton.vue?vue&type=template&id=63e2e880"
import script from "./SignOutButton.vue?vue&type=script&lang=js"
export * from "./SignOutButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\yasukochi\\Work\\11_Marron\\00_Working\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__